export const isOrderIdSearch = (input: string): boolean => /^(?:\d{7}|(?![49])\d{8})$/.test(input);

export const validateSearchInput = (input: string): string | null => {
    if (!input) return null;
    if (isOrderIdSearch(input)) return null;
    const isDigitsOnly = /^\d+$/.test(input);
    if (isDigitsOnly) {
        if (input.length !== 8 && input.length !== 15) {
            return "Telefonnummer må være 8 siffer og IMEI må være 15 siffer";
        }
    }
    return null;
};

export const normalizeSearchInput = (input: string): string => {
    const trimmed = input.trim();
    // remove spaces for digit-only input
    return /^[\d\s]+$/.test(trimmed) ? trimmed.replace(/\s/g, "") : trimmed;
};
